// extracted by extract-css-chunks-webpack-plugin
module.exports = {"ProdImgContainer":"BvCJA","tagNew":"eC-RZ","tagFewLeft":"D4Zz5","addToListContainer":"uz2Uk"};